import { useState } from "react";
import { stopImpersonation } from "@/lib/api";
import { useCurrentUserStore } from "@/stores/useCurrentUserStore";

/**
 * 成り代わり中に画面下部へ常時表示するバナー。誰として操作しているかを示し、
 * ワンクリックで元のユーザー (SuperAdmin) に戻れるようにする。
 */
export function ImpersonationBanner() {
	const impersonator = useCurrentUserStore((s) => s.impersonator);
	const firstName = useCurrentUserStore((s) => s.firstName);
	const lastName = useCurrentUserStore((s) => s.lastName);
	const [stopping, setStopping] = useState(false);
	const [error, setError] = useState<string | null>(null);

	if (!impersonator) return null;

	const handleStop = async () => {
		setStopping(true);
		setError(null);
		try {
			await stopImpersonation();
			// ストアやキャッシュが対象ユーザーの状態を持っているため、全リロードで確実にリセットする。
			window.location.replace("/");
		} catch (err) {
			setError(err instanceof Error ? err.message : "操作の終了に失敗しました。");
			setStopping(false);
		}
	};

	return (
		<div
			data-testid="impersonation-banner"
			style={{
				position: "fixed",
				bottom: 16,
				left: "50%",
				transform: "translateX(-50%)",
				zIndex: 1000,
				display: "flex",
				alignItems: "center",
				gap: 12,
				padding: "8px 10px 8px 16px",
				background: "var(--danger-subtle)",
				color: "var(--danger)",
				borderRadius: "var(--radius-full)",
				boxShadow: "var(--shadow-popover)",
				fontSize: "var(--text-ui)",
				fontWeight: 500,
				whiteSpace: "nowrap",
			}}
		>
			<span>
				{lastName} {firstName} として操作中
			</span>
			{error && <span style={{ fontWeight: 400 }}>{error}</span>}
			<button
				type="button"
				disabled={stopping}
				onClick={handleStop}
				style={{
					padding: "5px 12px",
					background: "var(--danger-solid)",
					color: "var(--on-neutral-solid)",
					border: 0,
					borderRadius: "var(--radius-full)",
					fontSize: "var(--text-caption)",
					fontWeight: 600,
					fontFamily: "inherit",
					cursor: stopping ? "default" : "pointer",
					opacity: stopping ? 0.6 : 1,
				}}
			>
				終了
			</button>
		</div>
	);
}
